import { lives } from "@/mocks/lives";
import { anchors, getAnchorById } from "@/mocks/anchors";
import type { Live } from "@/types/live";

export interface FilterOptions {
  keyword?: string;
  region?: string;
  status?: string;
  level?: string;
  sort?: string;
}

export const getLiveById = (id: string): Live | undefined =>
  lives.find((item) => item.id === id);

export const getAnchorName = (anchorId: string): string =>
  getAnchorById(anchorId)?.name ?? "神秘主播";

export const filterLives = (options: FilterOptions): Live[] => {
  const { keyword = "", region = "all", status = "all", level = "all", sort = "hot" } = options;
  const key = keyword.trim().toLowerCase();

  let result = lives.filter((item) => {
    if (key) {
      const anchorName = getAnchorName(item.anchorId).toLowerCase();
      const matchedTitle = item.title.toLowerCase().includes(key);
      const matchedAnchor = anchorName.includes(key);
      const matchedTag = item.tags.some((tag) => tag.toLowerCase().includes(key));
      if (!matchedTitle && !matchedAnchor && !matchedTag) return false;
    }
    if (region !== "all" && item.region !== region) return false;
    if (status !== "all" && item.status !== status) return false;
    if (level !== "all") {
      const anchor = anchors.find((a) => a.id === item.anchorId);
      if (!anchor || anchor.level !== level) return false;
    }
    return true;
  });

  result = [...result];
  if (sort === "viewers") {
    result.sort((a, b) => b.viewers - a.viewers);
  } else if (sort === "time") {
    result.sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime());
  } else {
    result.sort((a, b) => {
      if (a.status !== b.status) return a.status === "live" ? -1 : 1;
      return b.viewers - a.viewers;
    });
  }
  return result;
};

export const getLivesByCategory = (categoryKey: string, options: FilterOptions = {}): Live[] =>
  filterLives({ ...options, keyword: "" }).filter((item) => item.categoryKey === categoryKey);

export const getRelatedLives = (live: Live, limit = 4): Live[] => {
  const sameAnchor = lives.filter((item) => item.id !== live.id && item.anchorId === live.anchorId);
  const sameCategory = lives.filter(
    (item) =>
      item.id !== live.id &&
      item.categoryKey === live.categoryKey &&
      !sameAnchor.some((s) => s.id === item.id),
  );
  return [...sameAnchor, ...sameCategory].slice(0, limit);
};

export const getHotLives = (limit = 5): Live[] =>
  lives.filter((item) => item.hot).slice(0, limit);

export const getLatestLives = (limit = 8): Live[] =>
  [...lives]
    .filter((item) => item.status === "live")
    .sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime())
    .slice(0, limit);

export const HOT_KEYWORDS = ["游戏教学", "深夜电台", "民谣弹唱", "舞蹈", "脱口秀", "露营"];